<template>
    <div class="p-admin-conf-consultation">
        <div class="card mb-3">
            <div class="card-header">タイムゾーン設定</div>
            <div class="card-body" v-if="configurations">
                <div v-for="(conf, index) in configurations">
                    <template v-if="conf.category === confCategory.timezone">
                        <div v-if="conf.value_type === confValue.bool" class="m-1">
                            <div class="form-group m-form__group">
                                <label
                                    v-if="conf.is_display_name"
                                    :for="`key-${conf.key}`"
                                    class="vc-conf-name">
                                    {{ conf.name }}：
                                </label>
                                <div>
                                    <div class="form-check mb-1">
                                        <input
                                            v-model="configurations[index].value"
                                            value="1"
                                            :id="`key-${conf.key}_1`"
                                            class="form-check-input"
                                            :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                            type="radio">
                                        <label
                                            :for="`key-${conf.key}_1`"
                                            style="cursor:pointer;"
                                            class="form-check-label">
                                            {{ conf.label_bool_1 }}
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input
                                            v-model="configurations[index].value"
                                            value="0"
                                            :id="`key-${conf.key}_2`"
                                            class="form-check-input"
                                            :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                            type="radio">
                                        <label
                                            :for="`key-${conf.key}_2`"
                                            style="cursor:pointer;"
                                            class="form-check-label">
                                            {{ conf.label_bool_2 }}
                                        </label>
                                    </div>
                                </div>
                                <div v-if="errors[ `${index}.${helper.valueField(conf)}` ]" class="invalid-feedback d-block mt-1">
                                    {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="d-flex justify-content-end">
                    <button
                        @click="updateConfigurations"
                        :disabled="inProgress"
                        class="btn btn-yokumiru-orange btn-settings mt-3">
                        保存
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'

export default {
    props: {
        conf: {
            type: Array,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            configurations: [],
            errors: {},
            inProgress: false,
            confCategory: constants.confCategory,
            confValue: constants.confValue,
        }
    },

    computed: {
        /**
         * 更新データ準備
         *
         * @return {object}
         */
        preparedConfigurations: function () {
            return this.helper.bindConfigurationsValue(this.configurations)
        },
    },

    methods: {
        /**
         * 設定更新
         */
        updateConfigurations: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.configurations.endpoint.base

            await axios.post(endpoint, this.preparedConfigurations)
                .then(() => {
                    this.errors = {}
                    bus.$emit('alert-success', '設定を更新しました。')
                })
                .catch(({response}) => {
                    this.errors = response.data.errors
                    bus.$emit('alert-danger')
                })

            this.inProgress = false
        },
    },

    watch: {
        conf: function (conf) {
            this.configurations = conf
        },
    }
}
</script>

<style lang="scss" scoped>
.vc-conf-name {
    color: #5f5f5f;
    font-size: 13px;
    font-weight: bold;
}

.vc-input-int {
    max-width: 100px;
}
</style>
